export default __webpack_public_path__ + "static/media/pic9.0034011e.jpg";